// extracted by mini-css-extract-plugin
export default {"logo":"youroffersaiEm-T","placeholder":"youroffersKaThmn","logo__image":"yourofferswILiW4"};